import { Stack } from '@whistler-ui/k2/components/Stack';
import { Heading, Paragraph } from '@whistler-ui/k2/components/Typography';

export interface PhaseStep {
  id: number;
  label: string;
}

interface PhaseCardProps {
  title: string;
  subtitle: string;
  badgeText: string;
  steps: PhaseStep[];
  theme: string;
}

const mainStyles = {
  netlync: {
    titleText: 'text-[#008cb4]',
    badgeBg: 'bg-[#e0f2f8]',
    badgeText: 'text-[#008cb4]',
    circleBg: 'bg-[#e0f2f8]',
    circleText: 'text-[#008cb4]',
  },
  gsma: {
    titleText: 'text-[#DC002B]',
    badgeBg: 'bg-red-100',
    badgeText: 'text-[#DC002B]',
    circleBg: 'bg-red-100',
    circleText: 'text-[#DC002B]',
  },
  live: {
    titleText: 'text-[#106b53]',
    badgeBg: 'bg-[#e3f4ec]',
    badgeText: 'text-[#106b53]',
    circleBg: 'bg-[#e3f4ec]',
    circleText: 'text-[#106b53]',
  },
};

export const PhaseCard = ({
  title,
  subtitle,
  badgeText,
  steps,
  theme,
}: PhaseCardProps) => {
  const styles = mainStyles[theme] || mainStyles.netlync;

  return (
    <aside className="border border-gray-200 rounded-xl p-6 bg-white flex-1 h-121.5">
      <Stack className="mb-6">
        <Stack align="center" justify="between" direction="row">
          <Heading level={3}>
            <span className={styles.titleText}>{title}</span>
          </Heading>
          <span
            className={`px-3 py-1 rounded-full text-xs font-semibold ${styles.badgeBg} ${styles.badgeText}`}
          >
            {badgeText}
          </span>
        </Stack>
        <Paragraph>{subtitle}</Paragraph>
      </Stack>

      <Stack direction="column" gap={3}>
        {steps.map(step => (
          <Stack
            key={step.id}
            align="center"
            gap={4}
            direction="row"
            className="p-3.5 border border-gray-100 rounded-lg"
          >
            <Stack
              justify="center"
              direction="row"
              align="center"
              className={`w-8 h-8 rounded-full font-semibold text-sm shrink-0 ${styles.circleBg} ${styles.circleText}`}
            >
              {step.id}
            </Stack>
            <Paragraph>{step.label}</Paragraph>
          </Stack>
        ))}
      </Stack>
    </aside>
  );
};
